'use client';
import React, { useState } from 'react';

import ReactPlayer from 'react-player';

import type { Media as MediaType } from '../../../payload/payload-types';
import { MusterProps } from '@/app/_blocks/MusterGraphQL/types';
import type { ButtonAppearance, ButtonType } from '../Button';
import { Button } from '../Button';
import { Media } from '../Media';
import SemanticHeading, { SemanticHeadingData } from '../SemanticHeading';
import { renderTrademarkText } from '../TrademarkText';

import classes from './Muster.module.scss';
import { DebugJsonBlock } from '../DebugJsonBlock';
import { Gutter } from '../Gutter';

export const Muster: React.FC<{
  className?: string;
  muster: MusterProps;
}> = ({ className, muster }) => {
  const image = muster.image as MediaType;
  const imageAlignment = muster.imageAlignment || 'right';
  const [isPlaying, setIsPlaying] = useState(false);
  return (
    <Gutter>
      <div className={[className, classes.wrapper, imageAlignment === 'left' && classes.imageLeft].filter(Boolean).join(' ')}>
        <div className={classes.content}>
          <SemanticHeading
            heading={muster.musterTitle as SemanticHeadingData}
            fallbackText={muster.title_legacy || ''}
            fallbackTag="h2"
          />
          {muster.description &&
            muster.description
              .split(/\r?\n/)
              .filter(paragraph => paragraph.trim() !== '')
              .map((paragraph, idx) => (
                <p key={idx} className={classes.paragraph}>
                  {renderTrademarkText(paragraph)}
                </p>
              ))}
          <div className={classes.buttons}>
            {muster.buttons.map((item, index) => {
              const { button: btnItem } = item;
              return btnItem.hideButton ? null : (
                <Button
                  key={`${item.id}-${index}`}
                  type={(btnItem.musterButtonType || 'reference') as ButtonType}
                  appearance={btnItem.musterButtonStyle as ButtonAppearance}
                  href={btnItem.musterButtonType === 'custom' ? btnItem?.url : undefined}
                  reference={btnItem.musterButtonType === 'reference' ? btnItem?.reference : undefined}
                  document={
                    btnItem.musterButtonType === 'download' &&
                    btnItem.document &&
                    typeof btnItem.document === 'object'
                      ? btnItem.document
                      : undefined
                  }
                  label={btnItem.label}
                  newTab={btnItem.newTab}
                  isMuster
                  width="85%"
                />
              );
            })}
          </div>
        </div>
        <div className={classes.imageCol}>
          {muster.videoUrl ? (
            <div
              className={classes.videoWrapper}
              style={{
                aspectRatio: `${muster.videoAspectWidth || 3} / ${muster.videoAspectHeight || 4}`,
              }}
            >
              <ReactPlayer
                src={muster.videoUrl}
                width="100%"
                height="100%"
                controls
                playing={isPlaying}
                onClickPreview={() => setIsPlaying(true)}
              />
            </div>
          ) : (
            image && (
              <Media
                resource={image}
                alt={image?.alt || ''}
                className={classes.image}
                imageSize="landscape"
              />
            )
          )}
        </div>
        <DebugJsonBlock block={muster} label="Muster" />
      </div>
    </Gutter>
  );
};

export default Muster;
